import types from './types';
import { isEqual } from 'lodash';

const initialState = {
  meta: {
    uploadingAttachment: false
  },
  selectedChannel: {},
  unreadMessageCount: 0,
  channelsWithUnreadMessages: {},
  channelMessagesInitialFetchTimestamps: {},
  managerOverview: {
    performingQuery: false,
    currentQuery: {},
    nextTokens: {},
    messages: []
  }
};

export const messagingReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.UPLOAD_ATTACHMENT_TO_CHANNEL_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          uploadingAttachment: true
        }
      };
    }
    case types.UPLOAD_ATTACHMENT_TO_CHANNEL_SUCCESS:
    case types.UPLOAD_ATTACHMENT_TO_CHANNEL_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          uploadingAttachment: false
        }
      };
    }
    case types.CHANNEL_RECEIVED_NEW_MESSAGE: {
      let channelsWithUnreadMessagesCopy = { ...state.channelsWithUnreadMessages };

      if (channelsWithUnreadMessagesCopy[action.channelId]) {
        channelsWithUnreadMessagesCopy[action.channelId] += 1;
      } else {
        channelsWithUnreadMessagesCopy[action.channelId] = 1;
      }

      return {
        ...state,
        unreadMessageCount: state.unreadMessageCount + 1,
        channelsWithUnreadMessages: channelsWithUnreadMessagesCopy
      };
    }
    case types.SELECT_CHANNEL: {
      // passed an empty object since we navigated away from chat messaging completely, just return the state
      if (Object.keys(action.channel).length === 0 && action.channel.constructor === Object) {
        return {
          ...state,
          selectedChannel: {}
        };
      }

      let channelsWithUnreadMessagesCopy = { ...state.channelsWithUnreadMessages };
      const selectedChannelUnreadMessageCount = state.channelsWithUnreadMessages[action.channel.id] || 0;

      if (channelsWithUnreadMessagesCopy[action.channel.id]) {
        delete channelsWithUnreadMessagesCopy[action.channel.id];
      }

      return {
        ...state,
        selectedChannel: action.channel,
        canMessageSelectedInChannel: action.channel.directMessage,
        channelsWithUnreadMessages: channelsWithUnreadMessagesCopy,
        unreadMessageCount: state.unreadMessageCount - selectedChannelUnreadMessageCount,
        channelMessagesInitialFetchTimestamps: {
          ...state.channelMessagesInitialFetchTimestamps,
          [action.channel.id]: new Date().toISOString()
        }
      };
    }
    case types.RESTORE_UNREAD_MESSAGE_COUNT: {
      return {
        ...state,
        channelsWithUnreadMessages: action.countsByChannel,
        unreadMessageCount: state.unreadMessageCount + Object.values(action.countsByChannel).reduce((initial, next) => initial + next, 0)
      };
    }
    case types.MANAGER_MESSAGES_OVERVIEW_REQUEST: {
      let resetMessagesArray = false;

      if (action.query) {
        resetMessagesArray = !isEqual(action.query, state.managerOverview.currentQuery);
      }

      return {
        ...state,
        managerOverview: {
          ...state.managerOverview,
          currentQuery: resetMessagesArray ? action.query : state.managerOverview.currentQuery,
          messages: resetMessagesArray ? [] : state.managerOverview.messages,
          performingQuery: true
        }
      };
    }
    case types.MANAGER_MESSAGES_OVERVIEW_SUCCESS: {
      return {
        ...state,
        managerOverview: {
          ...state.managerOverview,
          messages: [...state.managerOverview.messages, ...action.messages],
          nextTokens: {
            ...action.nextTokens
          },
          performingQuery: false
        }
      };
    }
    case types.MANAGER_MESSAGES_OVERVIEW_FAILURE: {
      return {
        ...state,
        managerOverview: {
          ...state.managerOverview,
          performingQuery: false
        }
      };
    }
    default:
      return state;
  }
};
